'use strict';

var MarketAnalysisGridDirective = function MarketAnalysisGridDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/market-analysis-grid.html'),
    controller: 'MarketAnalysisGridController',
    scope: {
      mode: '@',
      isDemandManagement: '=?',
      screen: '@',
      reoptPreviewData: '=',
      confirmAdjustmentsClearOnRefresh: '=?',
      screenState: '='
    }
  };
};
MarketAnalysisGridDirective.$inject = [];
module.exports = MarketAnalysisGridDirective;